import type { InferOutput } from "valibot";

export const linkSchema = v.object({
  title: v.string(),
  url: v.pipe(v.string(), v.url()),
  target: v.optional(v.string()),
  class: v.string(),
});
export type Link = InferOutput<typeof linkSchema>;
